import { useCallback, useEffect } from 'react';
import { debounce } from '../../modules/utility/debounce.js';

/**
 * A hook to return a debounced version of a function
 * @param {function} callback Callback function to be debounced
 * @param {number} wait Debounce time in milliseconds
 * @param {object} options Optional, additional options for the debounced function
 * @returns {function} A memoized, debounced version of the callback function
 */

var useDebounce = function useDebounce(callback, wait, options) {
  var debounced = useCallback(debounce(callback, wait, options), [callback, wait, options]);
  useEffect(function () {
    // prevent the debounced function executing after unmounting
    return function () {
      debounced.cancel();
    };
  }, []);
  return debounced;
};

var useDebounce$1 = useDebounce;

export { useDebounce$1 as default };
